import { render, staticRenderFns } from "./Alergii.vue?vue&type=template&id=c2ad38fc&"
import script from "./Alergii.vue?vue&type=script&lang=js&"
export * from "./Alergii.vue?vue&type=script&lang=js&"
import style0 from "./Alergii.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports